import { ApiClientProps } from "hooks/useApi";

export interface Partner {
  id: number;
  key: string;
  name: string;
}

async function getPartners(
  apiClient: ApiClientProps
): Promise<Partner[] | undefined> {

  try {
    const response = await apiClient.get({
      path: "/middleware-admin/partners",
    });

    return response.resource;
  } catch (error) {
    throw new Error(error as string);
  }
}

export default getPartners;
